module.exports = __webpack_public_path__ + "img/discard_silo_img5.985b9057.jpeg";